/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccountCash } from '../models';
// @ts-ignore
import type { AccountSummary } from '../models';
// @ts-ignore
import type { ConciseMarketData } from '../models';
// @ts-ignore
import type { EquityOrderResult } from '../models';
// @ts-ignore
import type { EquityPosition } from '../models';
// @ts-ignore
import type { Instrument } from '../models';
// @ts-ignore
import type { PlaceValueOrderRequest } from '../models';
/**
 * Trading212AccountApi - axios parameter creator
 * @export
 */
export const Trading212AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search Trading212 tradeable instruments by ticker prefix or shortName (case-insensitive). Returns instrument metadata including currency, maxOpenQuantity, working schedule, extended hours, and ISIN.
         * @summary Look up Trading212 instrument metadata
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {FindInstrumentsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInstruments: async (query?: string, limit?: number, accountId?: FindInstrumentsAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-account/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve account cash information from Trading212 using API Key authentication
         * @summary Get account cash
         * @param {GetAccountCashAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCash: async (accountId?: GetAccountCashAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-account/cash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummary1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSummary1: async (accountId?: GetAccountSummary1AccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-account/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all active equity orders from Trading212 public API
         * @summary Get active orders
         * @param {GetOrders1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders1: async (accountId?: GetOrders1AccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-account/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all open equity positions from Trading212 public API
         * @summary Get open positions
         * @param {GetPositions1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions1: async (accountId?: GetPositions1AccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-account/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current stock price for a ticker from Trading212 portfolio
         * @summary Get stock price
         * @param {string} ticker 
         * @param {GetStockPrice1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockPrice1: async (ticker: string, accountId?: GetStockPrice1AccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getStockPrice1', 'ticker', ticker)
            const localVarPath = `/api/trading212-account/price/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place a market order for a specified GBP value of a ticker via Trading212 API Key authentication
         * @summary Place value order
         * @param {PlaceValueOrderRequest} placeValueOrderRequest 
         * @param {PlaceValueOrder1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeValueOrder1: async (placeValueOrderRequest: PlaceValueOrderRequest, accountId?: PlaceValueOrder1AccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeValueOrderRequest' is not null or undefined
            assertParamExists('placeValueOrder1', 'placeValueOrderRequest', placeValueOrderRequest)
            const localVarPath = `/api/trading212-account/order/value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeValueOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trading212AccountApi - functional programming interface
 * @export
 */
export const Trading212AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Trading212AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Search Trading212 tradeable instruments by ticker prefix or shortName (case-insensitive). Returns instrument metadata including currency, maxOpenQuantity, working schedule, extended hours, and ISIN.
         * @summary Look up Trading212 instrument metadata
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {FindInstrumentsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findInstruments(query?: string, limit?: number, accountId?: FindInstrumentsAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Instrument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findInstruments(query, limit, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.findInstruments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve account cash information from Trading212 using API Key authentication
         * @summary Get account cash
         * @param {GetAccountCashAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCash(accountId?: GetAccountCashAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountCash>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCash(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.getAccountCash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummary1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountSummary1(accountId?: GetAccountSummary1AccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountSummary1(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.getAccountSummary1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all active equity orders from Trading212 public API
         * @summary Get active orders
         * @param {GetOrders1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders1(accountId?: GetOrders1AccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquityOrderResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders1(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.getOrders1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all open equity positions from Trading212 public API
         * @summary Get open positions
         * @param {GetPositions1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions1(accountId?: GetPositions1AccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquityPosition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions1(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.getPositions1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve current stock price for a ticker from Trading212 portfolio
         * @summary Get stock price
         * @param {string} ticker 
         * @param {GetStockPrice1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockPrice1(ticker: string, accountId?: GetStockPrice1AccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConciseMarketData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockPrice1(ticker, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.getStockPrice1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Place a market order for a specified GBP value of a ticker via Trading212 API Key authentication
         * @summary Place value order
         * @param {PlaceValueOrderRequest} placeValueOrderRequest 
         * @param {PlaceValueOrder1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeValueOrder1(placeValueOrderRequest: PlaceValueOrderRequest, accountId?: PlaceValueOrder1AccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityOrderResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeValueOrder1(placeValueOrderRequest, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212AccountApi.placeValueOrder1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Trading212AccountApi - factory interface
 * @export
 */
export const Trading212AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Trading212AccountApiFp(configuration)
    return {
        /**
         * Search Trading212 tradeable instruments by ticker prefix or shortName (case-insensitive). Returns instrument metadata including currency, maxOpenQuantity, working schedule, extended hours, and ISIN.
         * @summary Look up Trading212 instrument metadata
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {FindInstrumentsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInstruments(query?: string, limit?: number, accountId?: FindInstrumentsAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Instrument>> {
            return localVarFp.findInstruments(query, limit, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve account cash information from Trading212 using API Key authentication
         * @summary Get account cash
         * @param {GetAccountCashAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCash(accountId?: GetAccountCashAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<AccountCash> {
            return localVarFp.getAccountCash(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve account summary including total value, cash breakdown, and investment P&L from Trading212 public API
         * @summary Get account summary
         * @param {GetAccountSummary1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSummary1(accountId?: GetAccountSummary1AccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<AccountSummary> {
            return localVarFp.getAccountSummary1(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all active equity orders from Trading212 public API
         * @summary Get active orders
         * @param {GetOrders1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders1(accountId?: GetOrders1AccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<EquityOrderResult>> {
            return localVarFp.getOrders1(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all open equity positions from Trading212 public API
         * @summary Get open positions
         * @param {GetPositions1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions1(accountId?: GetPositions1AccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<EquityPosition>> {
            return localVarFp.getPositions1(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current stock price for a ticker from Trading212 portfolio
         * @summary Get stock price
         * @param {string} ticker 
         * @param {GetStockPrice1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockPrice1(ticker: string, accountId?: GetStockPrice1AccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<ConciseMarketData> {
            return localVarFp.getStockPrice1(ticker, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Place a market order for a specified GBP value of a ticker via Trading212 API Key authentication
         * @summary Place value order
         * @param {PlaceValueOrderRequest} placeValueOrderRequest 
         * @param {PlaceValueOrder1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeValueOrder1(placeValueOrderRequest: PlaceValueOrderRequest, accountId?: PlaceValueOrder1AccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<EquityOrderResult> {
            return localVarFp.placeValueOrder1(placeValueOrderRequest, accountId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Trading212AccountApi - object-oriented interface
 * @export
 * @class Trading212AccountApi
 * @extends {BaseAPI}
 */
export class Trading212AccountApi extends BaseAPI {
    /**
     * Search Trading212 tradeable instruments by ticker prefix or shortName (case-insensitive). Returns instrument metadata including currency, maxOpenQuantity, working schedule, extended hours, and ISIN.
     * @summary Look up Trading212 instrument metadata
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {FindInstrumentsAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public findInstruments(query?: string, limit?: number, accountId?: FindInstrumentsAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).findInstruments(query, limit, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve account cash information from Trading212 using API Key authentication
     * @summary Get account cash
     * @param {GetAccountCashAccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public getAccountCash(accountId?: GetAccountCashAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).getAccountCash(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve account summary including total value, cash breakdown, and investment P&L from Trading212 public API
     * @summary Get account summary
     * @param {GetAccountSummary1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public getAccountSummary1(accountId?: GetAccountSummary1AccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).getAccountSummary1(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all active equity orders from Trading212 public API
     * @summary Get active orders
     * @param {GetOrders1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public getOrders1(accountId?: GetOrders1AccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).getOrders1(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all open equity positions from Trading212 public API
     * @summary Get open positions
     * @param {GetPositions1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public getPositions1(accountId?: GetPositions1AccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).getPositions1(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve current stock price for a ticker from Trading212 portfolio
     * @summary Get stock price
     * @param {string} ticker 
     * @param {GetStockPrice1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public getStockPrice1(ticker: string, accountId?: GetStockPrice1AccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).getStockPrice1(ticker, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place a market order for a specified GBP value of a ticker via Trading212 API Key authentication
     * @summary Place value order
     * @param {PlaceValueOrderRequest} placeValueOrderRequest 
     * @param {PlaceValueOrder1AccountIdEnum} [accountId] Which Trading 212 account to target. Defaults to primary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212AccountApi
     */
    public placeValueOrder1(placeValueOrderRequest: PlaceValueOrderRequest, accountId?: PlaceValueOrder1AccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212AccountApiFp(this.configuration).placeValueOrder1(placeValueOrderRequest, accountId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FindInstrumentsAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type FindInstrumentsAccountIdEnum = typeof FindInstrumentsAccountIdEnum[keyof typeof FindInstrumentsAccountIdEnum];
/**
 * @export
 */
export const GetAccountCashAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetAccountCashAccountIdEnum = typeof GetAccountCashAccountIdEnum[keyof typeof GetAccountCashAccountIdEnum];
/**
 * @export
 */
export const GetAccountSummary1AccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetAccountSummary1AccountIdEnum = typeof GetAccountSummary1AccountIdEnum[keyof typeof GetAccountSummary1AccountIdEnum];
/**
 * @export
 */
export const GetOrders1AccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetOrders1AccountIdEnum = typeof GetOrders1AccountIdEnum[keyof typeof GetOrders1AccountIdEnum];
/**
 * @export
 */
export const GetPositions1AccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetPositions1AccountIdEnum = typeof GetPositions1AccountIdEnum[keyof typeof GetPositions1AccountIdEnum];
/**
 * @export
 */
export const GetStockPrice1AccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type GetStockPrice1AccountIdEnum = typeof GetStockPrice1AccountIdEnum[keyof typeof GetStockPrice1AccountIdEnum];
/**
 * @export
 */
export const PlaceValueOrder1AccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type PlaceValueOrder1AccountIdEnum = typeof PlaceValueOrder1AccountIdEnum[keyof typeof PlaceValueOrder1AccountIdEnum];
